import React, { forwardRef } from 'react';

import { NumberInput } from '../NumberInput';

export const WeightInput = forwardRef(({ isGrams, ...rest }, ref) => (
  <NumberInput
    {...rest}
    prefix=""
    //suffix={isGrams ? ' g' : ' Kg'}
    decimalPlaces={isGrams ? 0 : 3}
    ref={ref}
    /*  InputProps={{
      endAdornment: (
        <InputAdornment position="end">{isGrams ? ' g' : ' Kg'}</InputAdornment>
      ),
    }} */
  />
));
